<template>
    <modal size="lg" @close="$emit('close')" ref="modal" :is-closeable="isCloseable" :autoshow="true">
        <template v-slot:title>
            Edit Reimbursement
        </template>
        <slot>
            <form-errors :errors="formErrors"/>

            <div class="mb-3 p-1 unpad-x bg-150 rounded">
                <div><span class="text-muted">Base Reimbursement Type: </span>{{ reimbursement.reimbursement_type.name }}</div>
                <div><span class="text-muted">Name: </span>{{ reimbursement.name }}</div>
            </div>

            <form class="mui-form" @submit.prevent="onSubmit()">
                <div class="form-row" v-if="canCustomize('name')">
                    <div class="col">
                        <form-input v-model="formData.name" :errors="errors.name" type="text" label="Name" />
                    </div>
                </div>
            </form>
        </slot>

        <template v-slot:footer>
            <button-row>
                <button type="button" class="btn btn-block btn-outline-primary" @click.prevent="close()">Cancel</button>
                <button type="button" class="btn btn-block btn-primary" @click.prevent="onSubmit()">Save</button>
            </button-row>
        </template>
    </modal>
</template>

<script>
import FormMixin from '@/mixins/Form'
import ModalMixin from '@/mixins/ModalMixin'

export default {
    props: ['reimbursement', 'client'],
    mixins: [FormMixin, ModalMixin],
    data() {
        return {
            formData: this.makeFormData(),
        }
    },
    methods: {
        canCustomize(fieldName) {
            return this.reimbursement?.reimbursement_type?.fields_to_customize?.includes(fieldName) || false
        },
        makeFormData() {
            return {
                name: this.reimbursement?.name || '',
            }
        },
        getFormData() {
            return this.formData
        },
        onSubmit() {
            this.$store.dispatch('START_LOADING')
            this.errors = {}
            this.formErrors = []
            return this.$api.put(`/clients/${this.client.id}/settings/reimbursement-types/${this.reimbursement.id}`, this.getFormData()).then(resp => {
                this.$store.dispatch('STOP_LOADING')
                this.$emit('updated', resp)
                this.close()
            }).catch(errors => {
                this.$store.dispatch('STOP_LOADING')
                this.errors = errors
                this.formErrors = errors.__all__
                this.onError()
            })
        },
    }
}
</script>
